module.exports = __webpack_public_path__ + "static/media/undraw_super_woman_dv0y.a3579253.svg";